import Carousel from 'react-bootstrap/Carousel';
import logo from '../assets/bg_logo.svg';
import './ServiceIntro.less';
import FormatListNumberedRtlIcon from '@mui/icons-material/FormatListNumberedRtl';
import RouteIcon from '@mui/icons-material/Route';
import DepartureBoardIcon from '@mui/icons-material/DepartureBoard';

const serviceData = [
  {
    icon: <FormatListNumberedRtlIcon sx={{ fontSize: 100 }} />,
    title: '城市公車一覽',
    description: '選取城市，便能一覽當地所有公車路線。'
  },
  {
    icon: <RouteIcon sx={{ fontSize: 100 }} />,
    title: '路線公車站點',
    description: '選取路線，便能一覽路線所有停靠站。'
  },
  {
    icon: <DepartureBoardIcon sx={{ fontSize: 100 }} />,
    title: '即時公車動態',
    description: '選取路線，便能查看各站進站動態。'
  }
];

function ServiceIntro() {
  return (
    <div className="service-intro-wrap">
    <h2>我們的服務，給您最好的體驗</h2>
    <div className="service-intro-container">
      {serviceData.map((service, index) => (
        <div className="service-intro" key={index}>
          <div className="icon">
            {service.icon}
          </div>
          <div className="text">
            <div className="title">
              {service.title}
            </div>
            <div className="description">
              {service.description}
            </div>
          </div>
        </div>
      ))}
      </div>
    </div>
  );
}

export default ServiceIntro;